export const BREAKPOINT_XS = 480;
export const BREAKPOINT_SM = 640;
export const BREAKPOINT_MD = 768;
export const BREAKPOINT_LG = 1024;
export const BREAKPOINT_XL = 1280;

export const BREAKPOINT_XS_QUERY = `(min-width: ${BREAKPOINT_XS}px)`;
export const BREAKPOINT_SM_QUERY = `(min-width: ${BREAKPOINT_SM}px)`;
export const BREAKPOINT_MD_QUERY = `(min-width: ${BREAKPOINT_MD}px)`;
export const BREAKPOINT_LG_QUERY = `(min-width: ${BREAKPOINT_LG}px)`;
export const BREAKPOINT_XL_QUERY = `(min-width: ${BREAKPOINT_XL}px)`;
